export default __webpack_public_path__ + "static/media/zayed-project-3.38b9166c.jpg";